import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/TopLayout.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'About About',
  //       meta: {
  //         title: '关于',
  //       },
  //       component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  //     }
  //   ]
  // },
  {
    path: '/agreement',
    name: 'UserAgreement',
    meta: {
      title: '用户协议',
    },
    component: () => import('../views/UserAgreement.vue')
  },
  {
    path: '/invitation',
    name: 'Invitation',
    // meta: {
    //   title: '邀请页',
    // },
    component: () => import('../views/Invitation.vue')
  },
  {
    path: '/player',
    name: 'Player',
    // meta: {
    //   title: '播放页',
    // },
    component: () => import('../views/Player.vue')
  },
  {
    path: '/card',
    name: 'Card',
    meta: {
      title: '卡片',
    },
    component: () => import('../views/imagesPage/Card.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // next()
  console.log(to.meta)
  if (from.path === '/questionnaire/answer' && to.path === '/questionnaire' && store.state.app.stopBack) {
    store.dispatch('app/setStopWindowShow', true)
    next(false)
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    } else {
      document.title = '天天学拍'
    }
    next()
  }
})

export default router